// The environment is picked from the address the app is opened on, so this
// file never needs editing before a deploy. ONLY the live web hosts below use
// the live API; localhost uses the local API; every other address (staging,
// preview deploys, anything unrecognised) uses the staging/dev API.
const LIVE_WEB_HOSTS = [
  "app.flexpro.ae",
];
const host = typeof window !== "undefined" ? window.location.hostname : "";
const isLocal = host === "localhost" || host === "127.0.0.1";
const isLive = LIVE_WEB_HOSTS.includes(host);

export const baseURL = isLocal
  ? "http://localhost:4500"
  : isLive
  ? "https://app-lmggt-crm-api.vercel.app"
  : "https://lmggt-api-staging.vercel.app";

export const FrontentUrl = isLocal
  ? "http://localhost:3000"
  : isLive
  ? "https://app-lmggt-crm-web.vercel.app"
  : "https://lmggt-web-staging.vercel.app";

export const ImageUploadAPI = baseURL + "/image-upload";
export const loginAPI = baseURL + "/login/pin-validate";
export const adminLoginAPI = baseURL + "/login/password-validate";
export const resetPasswordEmailAPI = baseURL + "/login/reset-password-email";
export const resetPasswordAPI = baseURL + "/login/reset-password";
export const pinResetAPI = baseURL + "/login/password-reset";
export const verifyOTPAPI = baseURL + "/login/verify-otp";
export const handleHrMasterAPI = baseURL + "/hr-master/";
export const hrMasterListAPI = baseURL + "/hr-master/list";
export const positionMasterAPI = baseURL + "/position-master/";
export const roleMasterInsertOrUpdateAPI = baseURL + "/role-master/insert";

export const projectMasterAPI = baseURL + "/project-master";

export const clientMasterAPI = baseURL + "/client-master";

export const addProductAPI = baseURL + "/product/insertProduct";
export const addBundleProductAPI = baseURL + "/product/bundle";
export const fetchBundlesAPI = baseURL + "/product/bundles";
// GET `${bundleByIdAPI}/:id` to prefill the edit form; PATCH the same URL to save.
export const bundleByIdAPI = baseURL + "/product/bundle";
export const addStoreAPI = baseURL + "/store/insertStore";
export const listStoreAPI = baseURL + "/store/listStore";
export const updateStoreAPI = baseURL + "/store/updateStore";
export const fetchStoreAPI = baseURL + "/store/fetchStoreById";
export const fetchProductsByStoreAPI = baseURL + "/store/fetchProductByStoreId";
export const storeFilterAPI = baseURL + "/store/storeFilter";

export const fetchReportsAPI = baseURL + "/store/reports";
export const salesExecDashboardAPI = baseURL + "/dashboard1/sales-exec";

export const uploadToVercelAPI = baseURL + "/file/upload-file";
export const deleteFromVercelAPI = baseURL + "/file/delete-file";



export const fetchProductReportsAPI = baseURL + "/store/product-reports";


export const productBulkUploadAPI = baseURL + "/product/bulkUpload";

export const fetchProductsAPI = baseURL + "/product/fetchProducts";
export const fetchProductByIdAPI = baseURL + "/product/fetchProductById";
export const updateProductAPI = baseURL + "/product/UpdateProduct";
export const deleteProductAPI = baseURL + "/product"; // + `/${id}`, DELETE
export const fetchProductDropdownAPI = baseURL + "/product/fetchProductsDropdown";
export const fetchProductUnitAPI = baseURL + "/product/fetchProductUnit";
export const productAvailabilityAPI = baseURL + "/product/availability"; // POST { store_id, product_ids }
export const productAvailabilityAllStoresAPI = baseURL + "/product/availability-all-stores"; // GET /:product_id
export const bundleAvailabilityAllStoresAPI = baseURL + "/product/bundle-availability-all-stores"; // GET /:product_id
export const fetchBuyingPriceAPI = baseURL + "/product/fetchBuyingPrice";
export const fetchCategoriesDDAPI = baseURL + "/product/categoriesDD";
export const updatestockadjustmentsAPI = baseURL + "/inventory/update";
export const InventoryHistoryAPI = baseURL + "/inventory/transactions";
export const AdjustmentsHistoryAPI = baseURL + "/inventory/adjustments";
export const GetSalesReportAPI = baseURL + "/inventory/getSalesReport";
export const GetUserWiseSalesReportAPI = baseURL + "/inventory/getUserWiseSalesReport";
export const GetProductSalesReportAPI = baseURL + "/inventory/getProductSalesReport";
export const GetSalesPerformanceReportAPI = baseURL + "/inventory/getSalesPerformanceReport";
export const GetSalesExecutivesDropdownAPI = baseURL + "/inventory/getSalesExecutivesDropdown";
export const GetSalesPersonProductBreakdownAPI = baseURL + "/inventory/getSalesPersonProductBreakdown";
export const GetProductSalesPersonBreakdownAPI = baseURL + "/inventory/getProductSalesPersonBreakdown";


export const storesDropdownAPI = baseURL + "/inventory/stores";
export const stockTransferAPI = baseURL + "/inventory/transfer";
export const stockTransferDataAPI = baseURL + "/inventory/stockDetails";
export const updateStockBatchPriceAPI = baseURL + "/inventory/update-batch-price";
export const productInStockAPI = baseURL + "/inventory/productInStockBystoreId";
export const productWiseInStockAPI = baseURL + "/inventory/productWiseInStock";
export const reservedStockDetailsAPI = baseURL + "/inventory/reservedStockDetails";
export const stockBulkUploadAPI = baseURL + "/inventory/bulkUpload";
export const GetPriceHistoryAPI = baseURL + "/inventory/getPriceHistory";
export const showPurchaseBreakdownAPI = baseURL + "/inventory/showPurchaseBreakdown";


export const insertOrderAPI = baseURL + "/order/create";
export const generateProformaAPI = baseURL + "/order/proforma";
export const fetchProformaListAPI = baseURL + "/order/proforma/list";
export const proformaBaseAPI = baseURL + "/order/proforma"; // + /:id, /:id (PUT), /:id/versions
export const proformaGrnCandidateAPI = baseURL + "/order/proforma"; // + /:id/grn-candidate
export const proformaGrnAPI = baseURL + "/order/proforma"; // + /:id/grn

// Proforma Quote — standalone clone of CDN above (own table/number sequence,
// own routes). See models/proformaQuoteModel.js on the backend.
export const generateProformaQuoteAPI = baseURL + "/proforma-quote";
export const fetchProformaQuoteListAPI = baseURL + "/proforma-quote/list";
export const proformaQuoteBaseAPI = baseURL + "/proforma-quote"; // + /:id, /:id (PUT), /:id/versions
export const proformaQuoteGrnCandidateAPI = baseURL + "/proforma-quote"; // + /:id/grn-candidate
export const proformaQuoteGrnAPI = baseURL + "/proforma-quote"; // + /:id/grn
export const invoiceAccessAPI = baseURL + "/position-master/invoice-access"; // current user's create/edit invoice access
export const fetchOrdersAPI = baseURL + "/order/all";

export const insertPoAPI = baseURL + "/po/create";
export const fetchPoAPI = baseURL + "/po/all";
export const updatePoByIdAPI = baseURL + "/po/update";
export const updateSoPaymentAPI = baseURL + "/order/payment";
export const fetchPoByIdAPI = baseURL + "/po/fetchPOById";
export const cancelPurchaseOrderOTPAPI = baseURL + "/po/send-otp";
export const cancelPurchaseOrderAPI = baseURL + "/po/cancel";



export const transactionHistoryAPI = baseURL + "/order/transaction-history";
export const cancelOrderOTPAPI = baseURL + "/order/send-otp";
export const cancelOrderAPI = baseURL + "/order/cancel";

export const fetchOrdernumberAPI = baseURL + "/order/numbers";
export const fetchOrderByIdAPI = baseURL + "/order/fetchOrderById";
export const fetchOrderDateHistoryAPI = baseURL + "/order/fetchOrderDateHistory";
export const convertCreditInvoiceAPI = baseURL + "/order"; // + `/${order_id}/convert-to-invoice`
export const settleAndConvertCreditInvoiceAPI = baseURL + "/order"; // + `/${order_id}/settle-and-convert`
export const invoiceConversionHistoryAPI = baseURL + "/order"; // + `/${order_id}/conversion-history`
export const paymentSettlementsAPI = baseURL + "/order/payment"; // + `/${payment_id}/settlements`
export const updateOrderByIdAPI = baseURL + "/order/update";

// --- FOC (Free of Charge) — Item 8 ---
export const submitFocRequestAPI = baseURL + "/foc/request";
export const fetchFocRequestsAPI = baseURL + "/foc/requests";
export const focRequestBaseAPI = baseURL + "/foc/requests"; // + /:id/approve, /:id/reject
export const fetchFocReportAPI = baseURL + "/foc/report";

// --- Missing Stock ---
export const createMissingStockAPI = baseURL + "/missing-stock";
export const fetchMissingStockAPI = baseURL + "/missing-stock";
export const missingStockBaseAPI = baseURL + "/missing-stock"; // + /:id/cancel, /:id/convert-to-foc

// --- Return / Exchange (Tax Credit Note) ---
export const returnableItemsAPI = baseURL + "/order"; // + `/${order_id}/returnable`
export const createReturnAPI = baseURL + "/order/returns";
export const createExchangeAPI = baseURL + "/order/exchange";
export const fetchReturnsAPI = baseURL + "/order/returns/all";
export const damagedReportAPI = baseURL + "/order/returns/damaged-report";
export const returnByIdAPI = baseURL + "/order/returns"; // + `/${id}`

export const insertCustomerAPI = baseURL + "/customer/add";
export const fetchCustomerAPI = baseURL + "/customer/fetch";
export const fetchCustomerByIdAPI = baseURL + "/customer/fetchCustomerById";
export const fetchCustomerDDAPI = baseURL + "/customer/customerDD";

export const updateCustomerByIdAPI = baseURL + "/customer/update";

export const insertCreditApprovalAPI = baseURL + "/credit-approval/request";
export const fetchPendingCreditApprovalsAPI = baseURL + "/credit-approval/pending";
export const fetchCreditApprovalListAPI = baseURL + "/credit-approval/all";
export const approveCreditApprovalAPI = baseURL + "/credit-approval/approve";
export const rejectCreditApprovalAPI = baseURL + "/credit-approval/reject";
export const myCreditRequestStatusAPI = baseURL + "/credit-approval/my-status";
export const creditApprovalBaseAPI = baseURL + "/credit-approval";

export const fetchCustomerStatementAPI = baseURL + "/customer-statement";
export const fetchCustomerStatementBalancesAPI = baseURL + "/customer-statement/balances";

export const fetchSalesTargetsAPI = baseURL + "/sales-targets";
export const saveSalesTargetAPI = baseURL + "/sales-targets";
export const bulkSalesTargetAPI = baseURL + "/sales-targets/bulk";
export const fetchSalesTargetReportAPI = baseURL + "/sales-targets/report";
export const fetchMonthwiseSalesTargetReportAPI = baseURL + "/sales-targets/monthwise-report";
export const fetchSalesTargetDashboardWidgetAPI = baseURL + "/sales-targets/dashboard-widget";
export const fetchSalesPersonsAPI = baseURL + "/sales-targets/sales-persons";

export const insertSalesCallAPI = baseURL + "/sales-call-report/add";
export const updateSalesCallByIdAPI = baseURL + "/sales-call-report/update";
export const fetchSalesCallByIdAPI =
  baseURL + "/sales-call-report/fetchById";
export const fetchSalesCallAPI = baseURL + "/sales-call-report/fetch";

export const insertVendorAPI = baseURL + "/vendors/add";
export const fetchVendorAPI = baseURL + "/vendors/fetch";
export const fetchVendorByIdAPI = baseURL + "/vendors/fetchVendorById";
export const fetchVendorDDAPI = baseURL + "/vendors/vendorDD";

export const updateVendorByIdAPI = baseURL + "/vendors/update";

export const forgotPasswordAPI = baseURL + "/forgot-password";
export const advancePaymentAPI = baseURL + "/advance-payments";
export const advancePaymentDetailsAPI = baseURL + "/advance-payment-details";
export const payslipAPI = baseURL + "/payslip";
export const statusMasterAPI = baseURL + "/status-master";
export const fetchUnitsAPI = baseURL + "/status-master/fetchUnits";
export const fetchStatusByParent = baseURL + "/status-master/fetchStatusByParent";



export const departmentMasterAPI = baseURL + "/department-master/";
export const payslipDetailsAPI = baseURL + "/payslip-details";
export const holidaydetailsAPI = baseURL + "/holiday-details";
export const paymentRequestAPI = baseURL + "/payment-request";
export const paymentRequestApprovalAPI = baseURL + "/payment-request/approval";
export const paymentRequestProcessAPI = baseURL + "/payment-request/process";
export const contractorAPI = baseURL + "/contractor";
export const attandenceAPI = baseURL + "/attandence";
export const employeeAttandenceAPI = baseURL + "/attandence-logout";
export const vendorAPI = baseURL + "/vendor";
export const fetchVendorsAPI = baseURL + "/vendor/fetch-vendors";

export const termsAndConditionsAPI = baseURL + "/terms-conditions/all";
export const termsAPI = baseURL + "/terms-conditions/insert";
export const termsUpdateAPI = baseURL + "/terms-conditions/update";

export const termsByIdAPI = baseURL + "/terms-conditions/:id";

export const calculatePOAPI = baseURL + "/purchase-order/calculate-po";
export const LabourAttandenceAPI = baseURL + "/attandence/labour";
export const purchaseOrderAPI = baseURL + "/purchase-order";
export const purchaseOrderListAPI = baseURL + "/purchase-order/list";
export const fetchPOAPI = baseURL + "/purchase-order/fetch-po";

export const poDateAPI = baseURL + "/purchase-order/poDate";

export const purchaseOrderItemsAPI = baseURL + "/purchase-order/items";
export const insertPurchaseOrderAPI =
  baseURL + "/purchase-order/insert-po-items";
export const dashboardAPI = baseURL + "/dashboard";
export const dashboardAPI1 = baseURL + "/dashboard1";
export const globalSearchAPI = baseURL + "/search/global";
// configuration > manageCompanies
export const manageCompaniesAPI = baseURL + "/manage-companies";
// master > invoice
export const manageInvoiceAPI = baseURL + "/invoice/create";
export const invoiceItemsAPI = baseURL + "/invoice/items";

// invoice terms and conditions
export const manageInvoiceTermsAndConditionsAPI =
  baseURL + "/invoice-terms-and-conditions";
export const manageStoreMasterAPI = baseURL + "/store";
export const labourWagesAPI = baseURL + "/labour-wages";
export const reportsAPI = baseURL + "/reports";
export const createPdfAPI = baseURL + "/create-pdf";
export const getPdfAPI = baseURL + "/fetch-pdf";
export const leaveAPI = baseURL + "/leave";
export const announcementAPI = baseURL + "/announcement";
export const GetDeliveryNotePdfAPI = baseURL + "/inventory/getDeliveryNotePdf";

export const userData = JSON.parse(localStorage.getItem("user"));
export const phoneRegExp = /^[0-9]{10}$/;
export const pincodeRegExp = /^[0-9]{6}$/;
export const bankaccountnumberRegExp = /^\d{9,18}$/;
export const ifscCodeRegExp = /^[A-Z]{4}0[A-Z0-9]{6}$/;
export const panCodeRegExp = /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$/;
export const gstNumberRegExp =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
export const emailRegExp = /^[a-z0-9]+@[a-z]+\.[a-z]{2,3}$/;
// export const urlRegExp = /^(https?|ftp):\/\/[^\s$.?#].[^\s]*$/i;
export const urlRegExp =
  /^(https?:\/\/)?(www\.)?[a-z0-9.-]+\.[a-z]{2,}(\/.*)?$/i;
export const trnNumber = /^[0-9]{15}$/;
const bearerToken = userData === null ? "" : userData.token;
export const config = {
  method: "",
  url: "",
  mode: "cors",
  headers: {
    "Content-Type": "application/json",
    Authorization: "Bearer " + bearerToken,
  },
  data: [],
};

export const _numberOnly = (event) => {
  if (!/[0-9]/.test(event.key)) {
    event.preventDefault();
  }
};

export const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result);
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};
